import {Directive, Input, ElementRef, Inject} from "@angular/core";

@Directive({
  selector: '[focus]'
})
export class FocusDirective {
  @Input() focus: boolean;

  constructor(@Inject(ElementRef) private element: ElementRef) {
  }
  /*ngOnInit() {
    this.element.nativeElement.focus();
  }*/
  ngOnChanges() {
    this.element.nativeElement.focus();
  }
}


// WEBPACK FOOTER //
// ./src/app/directive/focus.directive.ts